<template>
  <b-modal
    :id="'reportDamageInsuranceModal'"
    :visible="visible"
    :title="$t('message.ticketOverview.reportDamageInsurance')"
    hide-footer
    no-close-on-backdrop
    @hide="onHide">
    <p class="mb-2">
      {{ $t('message.ticketOverview.reportDamageInsuranceModal.description') }}
    </p>
    <div class="col p-0">
      <coozzy-button
        class="border mb-0"
        design="transparent"
        size="small"
        :disabled="reportDamageInsuranceLoading"
        @click="onCancel">
        {{ $t('message.generic.cancel') }}
      </coozzy-button>
      <coozzy-button
        class="float-right mb-0"
        design="green"
        size="small"
        :disabled="reportDamageInsuranceLoading"
        @click="reportDamageInsurance">
        {{ $t('message.ticketOverview.reportDamageInsuranceModal.confirmButton') }}
      </coozzy-button>
    </div>
  </b-modal>
</template>

<script>
import CoozzyButton from '@/framework/components/button/CoozzyButton.vue'
import Vue from 'vue'
import AicApi from '@/misc/apis/AicApi'
import { LandingPageEnum } from '@/types/api'

export default {
  name: 'ReportDamageInsuranceModal',
  components: {
    CoozzyButton
  },
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    ticketEntries: {
      type: Array,
      default: () => []
    },
    propertyEntries: {
      type: Array,
      default: () => []
    },
    objectEntries: {
      type: Array,
      default: () => []
    },
    deviceEntries: {
      type: Array,
      default: () => []
      }
  },
  data() {
    return {
      reportDamageInsuranceLoading: false
    }
  },
  methods: {
    onCancel() {
      if (this.reportDamageInsuranceLoading) {
        return
      }
      this.$emit('hide')
    },
    onHide(evt) {
      if (this.reportDamageInsuranceLoading) {
        evt.preventDefault()
        return
      }
      this.$emit('hide')
    },
    async reportDamageInsurance() {
      let uniquePropertyIds = new Set()

      if (this.ticketEntries.length > 0) {
        this.ticketEntries.forEach((ticket) => {
          ticket.references.forEach((ref) => {
            if (ref.id?.startsWith('prop_')) {
              uniquePropertyIds.add(ref.id)
            }
            if (ref.relatedIds?.length > 0) {
              const propertyId = ref.relatedIds.find((relatedId) =>
                relatedId?.startsWith('prop_')
              )
              if (propertyId) {
                uniquePropertyIds.add(propertyId)
              }
            }
          })
        })
      }
      if (this.propertyEntries.length > 0) {
        this.propertyEntries.forEach((property) => {
          const propertyId = property?.objectId || property?.objectID
          if (propertyId) {
            uniquePropertyIds.add(propertyId)
          }
        })
      }
      if (this.objectEntries.length > 0) {
        this.objectEntries.forEach((obj) => {
          if (obj?.id) {
            uniquePropertyIds.add(obj.id)
          }
        })
      }
      if (this.deviceEntries.length > 0) {
        this.deviceEntries.forEach((dev) => {
          if (dev?.referenceId) {
            uniquePropertyIds.add(dev.referenceId)
          }
        })
      }

      if (uniquePropertyIds.size === 0) {
        Vue.toasted.show(this.$t('message.loadingErrors.property'), { type: 'error' })
        this.$emit('hide')
        return
      }

      this.reportDamageInsuranceLoading = true

      const promises = Array.from(uniquePropertyIds).map((propertyId) =>
        AicApi.getSsoUrl(LandingPageEnum.AIC_LANDING_PAGE_CREATE_DAMAGE_REPORT, propertyId, this.ticketEntries.length > 0 ? this.ticketEntries[0].id : null)
      )

      try {
        const responses = await Promise.all(promises)
        responses.forEach((response) => {
          window.open(response.url, '_blank')
        })
      } catch (e) {
        Vue.toasted.show(this.$t('message.loadingErrors.aicSsoUrl'), { type: 'error' })
      } finally {
        this.reportDamageInsuranceLoading = false
        this.$emit('hide')
      }
    }
  }
}
</script>
